<template>
  <div class="tags-view-container" v-if="tagsView.visitedViews.length">
    <div class="tags-view-wrapper" ref="scrollPane">
      <router-link
        v-for="tag in tagsView.visitedViews"
        ref="tag"
        :key="tag.path"
        :class="['tags-view-item', { active: isActive(tag) }]"
        :to="{ path: tag.path, query: tag.query }"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <span class="tags-view-item-title">{{ tag.title }}</span>
        <span
          v-if="!tagsView.isFixedHome(tag.path)"
          class="el-icon-close tags-view-item-close"
          @click.prevent.stop="closeTag(tag)"
        ></span>
      </router-link>
    </div>

    <!-- 右键菜单 -->
    <ul
      v-show="visible"
      :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="context-menu"
    >
      <li @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags">关闭全部</li>
    </ul>
  </div>
</template>

<script>
import tagsView from '@/utils/tagsView'

export default {
  name: 'TagsView',
  data() {
    return {
      tagsView,
      visible: false,
      menuTop: 0,
      menuLeft: 0,
      selectedTag: {}
    }
  },
  computed: {
    currentRoute() {
      return this.$route
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.addEventListener('click', this.closeMenu)
      } else {
        document.removeEventListener('click', this.closeMenu)
      }
    },
    $route: {
      handler() {
        this.addTags()
        this.moveToCurrentTag()
      },
      immediate: false
    }
  },
  mounted() {
    this.addTags()
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },

    addTags() {
      const route = this.$route
      if (route.name) {
        tagsView.addView(route)
      }
    },

    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) return
      this.$nextTick(() => {
        const container = this.$refs.scrollPane
        if (!container) return
        const currentTag = Array.from(tags).find(tag => {
          return tag.to && tag.to.path === this.$route.path
        })
        if (currentTag) {
          currentTag.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
      })
    },

    closeTag(view) {
      tagsView.removeView(view)
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    toLastView() {
      const lastView = tagsView.toLastView(this.$route)
      if (lastView) {
        this.$router.push(lastView.fullPath)
      } else {
        this.$router.push(tagsView.fixedHomePath)
      }
    },

    openMenu(tag, e) {
      this.menuLeft = e.clientX
      this.menuTop = e.clientY
      this.visible = true
      this.selectedTag = tag
    },

    closeMenu() {
      this.visible = false
    },

    closeSelectedTag(view) {
      tagsView.removeView(view)
      this.closeMenu()
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    closeOthersTags() {
      tagsView.closeOthers(this.selectedTag)
      this.closeMenu()
      if (!this.isActive(this.selectedTag)) {
        this.$router.push(this.selectedTag.fullPath)
      }
    },

    closeAllTags() {
      tagsView.closeAll()
      this.closeMenu()
      this.$router.push(tagsView.fixedHomePath)
    }
  }
}
</script>

<style scoped>
.tags-view-container {
  height: auto;
  width: 100%;
  background-color: transparent;
  border-bottom: none;
  box-shadow: none;
  position: relative;
  margin-bottom: 10px;
}

.tags-view-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 0;
}

.tags-view-wrapper::-webkit-scrollbar {
  height: 3px;
}
.tags-view-wrapper::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 16px;
  margin: 0 6px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--header-text, #1a1a1a);
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  position: relative;
}

.tags-view-item:hover {
  color: #409EFF;
  border-color: #409EFF;
}

.tags-view-item.active {
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: none;
}

.tags-view-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 2px;
  background: #409EFF;
  border-radius: 1px;
}

.tags-view-item-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-view-item-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-left: 6px;
  font-size: 10px;
  transition: all 0.15s;
}

.tags-view-item-close:hover {
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.tags-view-item:not(.active) .tags-view-item-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #303133;
}

/* 右键菜单 */
.context-menu {
  position: fixed;
  z-index: 10001;
  margin: 0;
  padding: 4px 0;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  list-style: none;
  min-width: 120px;
  border: 1px solid #ebeef5;
}

.context-menu li {
  padding: 8px 20px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all 0.15s;
}

.context-menu li:hover {
  color: #409EFF;
  background-color: #f0f5ff;
}

/* ============ Dark Theme ============ */
.main-layout-wrapper[data-theme="dark"] .tags-view-item {
  color: var(--header-text, #f0f0f0);
  border-color: #333;
  background-color: #1e1e1e;
}

.main-layout-wrapper[data-theme="dark"] .tags-view-item:hover {
  color: #66b1ff;
  border-color: #409EFF;
}

.main-layout-wrapper[data-theme="dark"] .tags-view-item.active {
  color: #66b1ff;
  background-color: #1e1e1e;
  border-color: #409EFF;
  box-shadow: none;
}
.main-layout-wrapper[data-theme="dark"] .tags-view-item.active::after {
  background: #66b1ff;
}

.main-layout-wrapper[data-theme="dark"] .context-menu {
  background: #1e1e1e;
  border-color: #333;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.main-layout-wrapper[data-theme="dark"] .context-menu li {
  color: #ccc;
}

.main-layout-wrapper[data-theme="dark"] .context-menu li:hover {
  color: #409EFF;
  background-color: #252525;
}
</style>
